export class Imagen {

    public id : number;
    public base64:string;
    public descripcion:string;
    public codigoDocumento:string;
    public tipoDocumento:string;

}





// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/imagen.ts